/**
 * AUTO-GENERATED by packages/ui/scripts/generate-tokens.ts - do not edit by hand.
 * Regenerate: pnpm --filter @sosocio/ui run generate-tokens
 * Verify committed output is current: pnpm --filter @sosocio/ui run generate-tokens -- --check
 *
 * Derived from src/css/tailwind.css's @theme/@utility declarations (and, for
 * icon sizes only, packages/design-system/css/variables/defaults/foundations.css,
 * since tailwind.css exposes icon-size-* as an unenumerated wildcard utility).
 */

export const SEMANTIC_COLORS = [
	'background-brand-accent-fill-1',
	'background-brand-accent-fill-2',
	'background-brand-accent-fill-3',
	'background-brand-primary',
	'background-brand-primary-hover',
	'background-brand-primary-focus',
	'background-brand-primary-pressed',
	'background-brand-secondary',
	'background-brand-secondary-hover',
	'background-brand-secondary-focus',
	'background-brand-secondary-pressed',
	'background-canvas-canvas-primary',
	'background-canvas-canvas-secondary',
	'background-feedback-danger-1',
	'background-feedback-danger-2',
	'background-feedback-info-1',
	'background-feedback-info-2',
	'background-feedback-promotion-1',
	'background-feedback-promotion-2',
	'background-feedback-success-1',
	'background-feedback-success-2',
	'background-feedback-warning-1',
	'background-feedback-warning-2',
	'background-surface-disabled',
	'background-surface-fill-1',
	'background-surface-fill-2',
	'background-surface-fill-3',
	'background-surface-fill-4',
	'background-surface-fill-5',
	'background-surface-overlay',
	'border-brand-primary',
	'border-brand-primary-hover',
	'border-brand-primary-focus',
	'border-brand-primary-pressed',
	'border-neutral-border-1',
	'border-neutral-border-2',
	'border-neutral-border-3',
	'border-neutral-border-4',
	'border-neutral-border-5',
	'border-neutral-disabled',
	'border-utility-alignment-guide',
	'icon-brand-primary',
	'icon-brand-primary-hover',
	'icon-brand-primary-focus',
	'icon-brand-primary-pressed',
	'icon-brand-secondary',
	'icon-default-disabled',
	'icon-default-primary',
	'icon-default-secondary',
	'icon-default-tertiary',
	'icon-feedback-danger',
	'icon-feedback-info',
	'icon-feedback-success',
	'icon-feedback-warning',
	'text-brand-primary',
	'text-brand-primary-hover',
	'text-brand-primary-focus',
	'text-brand-primary-pressed',
	'text-brand-secondary',
	'text-default-disabled',
	'text-default-primary',
	'text-default-secondary',
	'text-default-tertiary',
	'text-feedback-danger',
	'text-feedback-info',
	'text-feedback-success',
	'text-feedback-warning',
	'utilities-elevation-drop-shadow-lg',
	'utilities-elevation-drop-shadow-md',
	'utilities-elevation-drop-shadow-sm',
	'utilities-elevation-drop-shadow-xs',
	'utilities-elevation-inner-shadow',
	'utilities-material-fills-overlay',
] as const;

export const TEXT_COLOR_ALIASES = [] as const;

export const BORDER_COLOR_ALIASES = [] as const;

export const FONT_SIZE_NAMES = [
	'text-heading-1',
	'text-heading-2',
	'text-heading-3',
	'text-body',
	'text-body-sm',
	'text-caption',
	'text-overline',
	'type-title-1',
	'type-title-2',
	'type-heading',
	'type-subtitle-1',
	'type-h5',
	'type-h6',
	'type-subtitle',
	'type-subtitle-strong',
	'type-body-1',
	'type-body-1-strong',
	'type-body-2',
	'type-link',
	'type-button',
	'type-caption',
	'type-caption-2',
] as const;

export const FONT_WEIGHT_NAMES = [
	'font-regular',
	'font-medium',
	'font-demi',
	'font-bold',
] as const;

export const FONT_FAMILY_NAMES = [
	'font-heading',
	'font-body',
	'font-body-demi',
] as const;

export const RADIUS_NAMES = [
	'control',
	'surface',
	'overlay',
	'full',
] as const;

export const ROUNDED_S_NAMES = ['overlay'] as const;

export const ROUNDED_E_NAMES = ['overlay'] as const;

export const ROUNDED_T_NAMES = ['overlay'] as const;

export const ROUNDED_B_NAMES = ['overlay'] as const;

export const SHADOW_NAMES = [
	'shadow-raised',
	'shadow-floating',
	'shadow-overlay',
	'shadow-inverse',
] as const;

export const Z_INDEX_NAMES = [
	'z-base',
	'z-raised',
	'z-sticky',
	'z-dropdown',
	'z-overlay',
	'z-modal-backdrop',
	'z-modal',
	'z-popover',
	'z-toast',
	'z-tooltip',
] as const;

export const DURATION_NAMES = [
	'duration-instant',
	'duration-fast',
	'duration-base',
	'duration-slow',
	'duration-slower',
] as const;

export const EASE_NAMES = [
	'ease-standard',
	'ease-emphasized',
	'ease-decelerate',
	'ease-accelerate',
	'ease-linear',
] as const;

export const CONTROL_HEIGHT_NAMES = [
	'h-control-sm',
	'h-control-md',
	'h-control-lg',
] as const;

export const CONTROL_MIN_HEIGHT_NAMES = [
	'min-h-control-sm',
	'min-h-control-md',
	'min-h-control-lg',
] as const;

export const CONTROL_PADDING_NAMES = [
	'p-control-sm',
	'p-control-md',
	'p-control-lg',
] as const;

export const CONTROL_PADDING_X_NAMES = ['px-control'] as const;

export const CONTROL_PADDING_Y_NAMES = [
	'py-control-sm',
	'py-control-md',
	'py-control-lg',
] as const;

export const CONTROL_GAP_NAMES = ['gap-control'] as const;

export const ICON_SIZE_NAMES = [
	'icon-size-xs',
	'icon-size-sm',
	'icon-size-md',
	'icon-size-lg',
	'icon-size-xl',
] as const;

export const ICON_HIT_AREA_NAMES = [
	'icon-hit-area-min',
	'icon-hit-area-recommended',
] as const;

export const ICON_TEXT_GAP_NAMES = [
	'icon-text-gap',
	'icon-text-gap-lg',
] as const;
